import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_color_picker = _resolveComponent("v-color-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createBlock(_component_v_row, { "no-gutters": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tabs_window, {
            modelValue: _ctx.activeTab,
            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.activeTab) = $event)),
            class: "tab_budget_form_mobile"
          }, {
            default: _withCtx(() => [
              (_ctx.showFirstPageSettings)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 0,
                    value: "showFirstPageSettings"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        style: {"overflow-x":"hidden"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "px-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                    default: _withCtx(() => [
                                      _cache[41] || (_cache[41] = _createElementVNode("b", { class: "pr-3" }, "Client", -1)),
                                      _createVNode(_component_v_divider)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex pl-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "4" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: _ctx.themeSettings.firstPage.client.name,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.themeSettings.firstPage.client.name) = $event)),
                                        label: "Nom client",
                                        dense: "",
                                        "hide-details": "auto",
                                        disabled: _ctx.readonly
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "4" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: _ctx.themeSettings.firstPage.client.logo,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.themeSettings.firstPage.client.logo) = $event)),
                                        label: "Logo client",
                                        dense: "",
                                        "hide-details": "auto",
                                        disabled: _ctx.readonly
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "4" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: _ctx.themeSettings.firstPage.client.address,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.themeSettings.firstPage.client.address) = $event)),
                                        label: "Adresse client",
                                        dense: "",
                                        "hide-details": "auto",
                                        disabled: _ctx.readonly
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex pl-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "4" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: _ctx.themeSettings.firstPage.client.siret,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.themeSettings.firstPage.client.siret) = $event)),
                                        label: "Siret client",
                                        dense: "",
                                        "hide-details": "auto",
                                        disabled: _ctx.readonly
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "4" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: _ctx.themeSettings.firstPage.client.ape,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.themeSettings.firstPage.client.ape) = $event)),
                                        label: "APE client",
                                        dense: "",
                                        "hide-details": "auto",
                                        disabled: _ctx.readonly
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "4" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: _ctx.themeSettings.firstPage.client.legalForm,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.themeSettings.firstPage.client.legalForm) = $event)),
                                        label: "Forme juridique",
                                        dense: "",
                                        "hide-details": "auto",
                                        disabled: _ctx.readonly
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "align-center my-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                    default: _withCtx(() => [
                                      _cache[42] || (_cache[42] = _createElementVNode("b", { class: "pr-3" }, "Cabinet", -1)),
                                      _createVNode(_component_v_divider)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex mt-2 pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: _ctx.themeSettings.firstPage.accountingFirm.position,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.themeSettings.firstPage.accountingFirm.position) = $event)),
                                        items: _ctx.position,
                                        label: "Position",
                                        "hide-details": "",
                                        required: true,
                                        disabled: _ctx.readonly,
                                        density: "compact"
                                      }, null, 8, ["modelValue", "items", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex pl-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "4" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: _ctx.themeSettings.firstPage.accountingFirm.name,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.themeSettings.firstPage.accountingFirm.name) = $event)),
                                        label: "Nom cabinet",
                                        dense: "",
                                        "hide-details": "auto",
                                        disabled: _ctx.readonly
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "4" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: _ctx.themeSettings.firstPage.accountingFirm.logo,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.themeSettings.firstPage.accountingFirm.logo) = $event)),
                                        label: "Logo cabinet",
                                        dense: "",
                                        "hide-details": "auto",
                                        disabled: _ctx.readonly
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, { cols: "4" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: _ctx.themeSettings.firstPage.accountingFirm.address,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.themeSettings.firstPage.accountingFirm.address) = $event)),
                                        label: "Adresse cabinet",
                                        dense: "",
                                        "hide-details": "auto",
                                        disabled: _ctx.readonly
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex pl-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "4" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: _ctx.themeSettings.firstPage.accountingFirm.siret,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.themeSettings.firstPage.accountingFirm.siret) = $event)),
                                        label: "Siret cabinet",
                                        dense: "",
                                        "hide-details": "auto",
                                        disabled: _ctx.readonly
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "align-center my-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                    default: _withCtx(() => [
                                      _cache[43] || (_cache[43] = _createElementVNode("b", { class: "pr-3" }, "Divers", -1)),
                                      _createVNode(_component_v_divider)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex pl-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "4" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: _ctx.themeSettings.firstPage.miscellaneous.title,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.themeSettings.firstPage.miscellaneous.title) = $event)),
                                        label: "Titre document",
                                        dense: "",
                                        "hide-details": "auto",
                                        disabled: _ctx.readonly
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "align-center my-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                    default: _withCtx(() => [
                                      _cache[44] || (_cache[44] = _createElementVNode("b", { class: "pr-3" }, "Styles", -1)),
                                      _createVNode(_component_v_divider)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex pl-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "12",
                                    class: "ml-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        class: "py-2 pt-3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3" }, {
                                            default: _withCtx(() => _cache[45] || (_cache[45] = [
                                              _createElementVNode("span", { class: "text--secondary" }, "Texte informations client", -1)
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    cols: "4",
                                                    class: "d-flex pl-2"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_select_filled, {
                                                        modelValue: 
                                                            _ctx.themeSettings.firstPage.client.style
                                                                .fontFamily
                                                        ,
                                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((
                                                            _ctx.themeSettings.firstPage.client.style
                                                                .fontFamily
                                                        ) = $event)),
                                                        items: _ctx.fontFamily,
                                                        label: "Police texte",
                                                        "hide-details": "",
                                                        disabled: _ctx.readonly,
                                                        density: "compact"
                                                      }, null, 8, ["modelValue", "items", "disabled"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, {
                                                    cols: "4",
                                                    class: "d-flex pl-2"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_select_filled, {
                                                        modelValue: 
                                                            _ctx.themeSettings.firstPage.client.style
                                                                .fontWeight
                                                        ,
                                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((
                                                            _ctx.themeSettings.firstPage.client.style
                                                                .fontWeight
                                                        ) = $event)),
                                                        items: _ctx.fontWeight,
                                                        label: "Format texte",
                                                        "hide-details": "",
                                                        disabled: _ctx.readonly,
                                                        density: "compact"
                                                      }, null, 8, ["modelValue", "items", "disabled"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, {
                                        "no-gutters": "",
                                        class: "py-2 pt-3"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { class: "d-flex align-center col-auto pr-3" }, {
                                            default: _withCtx(() => _cache[46] || (_cache[46] = [
                                              _createElementVNode("span", { class: "text--secondary" }, "Texte informations cabinet", -1)
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { cols: "12" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_col, {
                                                    cols: "4",
                                                    class: "d-flex pl-2"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_select_filled, {
                                                        modelValue: 
                                                            _ctx.themeSettings.firstPage.accountingFirm
                                                                .style.fontFamily
                                                        ,
                                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((
                                                            _ctx.themeSettings.firstPage.accountingFirm
                                                                .style.fontFamily
                                                        ) = $event)),
                                                        items: _ctx.fontFamily,
                                                        label: "Police texte",
                                                        "hide-details": "",
                                                        disabled: _ctx.readonly,
                                                        density: "compact"
                                                      }, null, 8, ["modelValue", "items", "disabled"])
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_v_col, {
                                                    cols: "4",
                                                    class: "d-flex pl-2"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_select_filled, {
                                                        modelValue: 
                                                            _ctx.themeSettings.firstPage.accountingFirm
                                                                .style.fontWeight
                                                        ,
                                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((
                                                            _ctx.themeSettings.firstPage.accountingFirm
                                                                .style.fontWeight
                                                        ) = $event)),
                                                        items: _ctx.fontWeight,
                                                        label: "Format texte",
                                                        "hide-details": "",
                                                        disabled: _ctx.readonly,
                                                        density: "compact"
                                                      }, null, 8, ["modelValue", "items", "disabled"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.showNextSettings)
                ? (_openBlock(), _createBlock(_component_v_window_item, {
                    key: 1,
                    value: "showNextSettings"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, {
                        "no-gutters": "",
                        style: {"overflow-x":"hidden"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "px-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "py-2 pt-1"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                    default: _withCtx(() => [
                                      _cache[47] || (_cache[47] = _createElementVNode("b", { class: "pr-3" }, "Client", -1)),
                                      _createVNode(_component_v_divider)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "d-flex align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex align-center pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_radio_group, {
                                        modelValue: _ctx.themeSettings.pages.client.logo,
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.themeSettings.pages.client.logo) = $event)),
                                        class: "d-flex align-center",
                                        inline: "",
                                        density: "compact",
                                        color: "primary",
                                        disabled: _ctx.readonly
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_radio, {
                                            label: "Nom",
                                            value: false,
                                            class: "pr-3"
                                          }),
                                          _createVNode(_component_v_radio, {
                                            label: "Logo",
                                            value: true
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex pl-2 pt-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: _ctx.themeSettings.pages.position.client,
                                        "onUpdate:modelValue": [
                                          _cache[17] || (_cache[17] = ($event: any) => ((_ctx.themeSettings.pages.position.client) = $event)),
                                          _cache[18] || (_cache[18] = ($event: any) => (
                                            _ctx.checkPositionAvailable(
                                                _ctx.themeSettings.pages.position.client,
                                                'client',
                                            )
                                        ))
                                        ],
                                        items: _ctx.position,
                                        label: "Position Client",
                                        "hide-details": "",
                                        required: true,
                                        disabled: _ctx.readonly,
                                        density: "compact"
                                      }, null, 8, ["modelValue", "items", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "py-2 pt-3 pl-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                    default: _withCtx(() => [
                                      _cache[48] || (_cache[48] = _createElementVNode("b", { class: "pr-3" }, "Cabinet", -1)),
                                      _createVNode(_component_v_divider)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex align-center pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_radio_group, {
                                        modelValue: _ctx.themeSettings.pages.accountingFirm.logo,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.themeSettings.pages.accountingFirm.logo) = $event)),
                                        class: "d-flex align-center",
                                        inline: "",
                                        density: "compact",
                                        color: "primary",
                                        disabled: _ctx.readonly
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_radio, {
                                            label: "Nom",
                                            value: false,
                                            class: "pr-3"
                                          }),
                                          _createVNode(_component_v_radio, {
                                            label: "Logo",
                                            value: true
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex pl-2 pt-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: _ctx.themeSettings.pages.position.accountingFirm,
                                        "onUpdate:modelValue": [
                                          _cache[20] || (_cache[20] = ($event: any) => ((_ctx.themeSettings.pages.position.accountingFirm) = $event)),
                                          _cache[21] || (_cache[21] = ($event: any) => (
                                            _ctx.checkPositionAvailable(
                                                _ctx.themeSettings.pages.position.client,
                                                'accountingFirm',
                                            )
                                        ))
                                        ],
                                        items: _ctx.position,
                                        label: "Position Cabinet",
                                        "hide-details": "",
                                        required: true,
                                        disabled: _ctx.readonly,
                                        density: "compact"
                                      }, null, 8, ["modelValue", "items", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "py-2 pt-3 pl-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                    default: _withCtx(() => [
                                      _cache[49] || (_cache[49] = _createElementVNode("b", { class: "pr-3" }, "Titre", -1)),
                                      _createVNode(_component_v_divider)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex pl-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_radio_group, {
                                        modelValue: _ctx.themeSettings.pages.miscellaneous.title,
                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.themeSettings.pages.miscellaneous.title) = $event)),
                                        class: "d-flex align-center",
                                        inline: "",
                                        density: "compact",
                                        color: "primary",
                                        disabled: _ctx.readonly
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_radio, {
                                            label: "Oui",
                                            value: true,
                                            class: "pr-3"
                                          }),
                                          _createVNode(_component_v_radio, {
                                            label: "Non",
                                            value: false
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex pl-2 pt-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: _ctx.themeSettings.pages.position.title,
                                        "onUpdate:modelValue": [
                                          _cache[23] || (_cache[23] = ($event: any) => ((_ctx.themeSettings.pages.position.title) = $event)),
                                          _cache[24] || (_cache[24] = ($event: any) => (
                                            _ctx.checkPositionAvailable(
                                                _ctx.themeSettings.pages.position.title,
                                                'title',
                                            )
                                        ))
                                        ],
                                        items: _ctx.position,
                                        label: "Position Titre",
                                        "hide-details": "",
                                        required: true,
                                        disabled: _ctx.readonly,
                                        density: "compact"
                                      }, null, 8, ["modelValue", "items", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "align-center pl-2 my-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      _cache[50] || (_cache[50] = _createElementVNode("b", { class: "pr-3" }, "Styles des polices", -1)),
                                      _createVNode(_component_v_divider)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex mt-2 mb-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: _ctx.themeSettings.pages.tables.header.fontWeight,
                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.themeSettings.pages.tables.header.fontWeight) = $event)),
                                        items: _ctx.fontWeight,
                                        label: "En-tête",
                                        "hide-details": "",
                                        disabled: _ctx.readonly,
                                        density: "compact"
                                      }, null, 8, ["modelValue", "items", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex pl-2 mt-2 mb-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: _ctx.themeSettings.pages.tables.rows.fontWeight,
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.themeSettings.pages.tables.rows.fontWeight) = $event)),
                                        items: _ctx.fontWeight,
                                        label: "Données",
                                        "hide-details": "",
                                        disabled: _ctx.readonly,
                                        density: "compact"
                                      }, null, 8, ["modelValue", "items", "disabled"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex pl-2 mt-2 mb-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: _ctx.themeSettings.pages.tables.footer.fontWeight,
                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.themeSettings.pages.tables.footer.fontWeight) = $event)),
                                        items: _ctx.fontWeight,
                                        label: "Pied de page",
                                        "hide-details": "",
                                        disabled: _ctx.readonly,
                                        density: "compact"
                                      }, null, 8, ["modelValue", "items", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex align-center" }, {
                                    default: _withCtx(() => [
                                      _cache[51] || (_cache[51] = _createElementVNode("b", { class: "pr-3" }, "Styles des couleurs", -1)),
                                      _createVNode(_component_v_divider)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex mt-2 mb-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_menu, { "offset-y": "" }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, _mergeProps({
                                                    modelValue: 
                                                            _ctx.themeSettings.pages.tables.header
                                                                .backgroundColor
                                                        ,
                                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((
                                                            _ctx.themeSettings.pages.tables.header
                                                                .backgroundColor
                                                        ) = $event))
                                                  }, props, {
                                                    label: "En-tête",
                                                    readonly: "",
                                                    disabled: _ctx.readonly,
                                                    "hide-details": "",
                                                    density: "compact"
                                                  }), null, 16, ["modelValue", "disabled"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_color_picker, {
                                            modelValue: 
                                                _ctx.themeSettings.pages.tables.header.backgroundColor
                                            ,
                                            "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((
                                                _ctx.themeSettings.pages.tables.header.backgroundColor
                                            ) = $event)),
                                            "show-swatches": "",
                                            "hide-sliders": "",
                                            "hide-inputs": "",
                                            "hide-mode-switch": "",
                                            swatches: _ctx.swatches
                                          }, null, 8, ["modelValue", "swatches"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex pl-2 mt-2 mb-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_menu, { "offset-y": "" }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, _mergeProps({
                                                    modelValue: 
                                                            _ctx.themeSettings.pages.tables.rows
                                                                .backgroundColor
                                                        ,
                                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((
                                                            _ctx.themeSettings.pages.tables.rows
                                                                .backgroundColor
                                                        ) = $event))
                                                  }, props, {
                                                    label: "Données",
                                                    readonly: "",
                                                    disabled: _ctx.readonly,
                                                    "hide-details": "",
                                                    density: "compact"
                                                  }), null, 16, ["modelValue", "disabled"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_color_picker, {
                                            modelValue: 
                                                _ctx.themeSettings.pages.tables.rows.backgroundColor
                                            ,
                                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((
                                                _ctx.themeSettings.pages.tables.rows.backgroundColor
                                            ) = $event)),
                                            "show-swatches": "",
                                            "hide-sliders": "",
                                            "hide-inputs": "",
                                            "hide-mode-switch": "",
                                            swatches: _ctx.swatches
                                          }, null, 8, ["modelValue", "swatches"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex pl-2 mt-2 mb-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_menu, { "offset-y": "" }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, _mergeProps({
                                                    modelValue: 
                                                            _ctx.themeSettings.pages.tables.footer
                                                                .backgroundColor
                                                        ,
                                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((
                                                            _ctx.themeSettings.pages.tables.footer
                                                                .backgroundColor
                                                        ) = $event))
                                                  }, props, {
                                                    label: "Pied de page",
                                                    readonly: "",
                                                    disabled: _ctx.readonly,
                                                    "hide-details": "",
                                                    density: "compact"
                                                  }), null, 16, ["modelValue", "disabled"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_color_picker, {
                                            modelValue: 
                                                _ctx.themeSettings.pages.tables.footer.backgroundColor
                                            ,
                                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((
                                                _ctx.themeSettings.pages.tables.footer.backgroundColor
                                            ) = $event)),
                                            "show-swatches": "",
                                            "hide-sliders": "",
                                            "hide-inputs": "",
                                            "hide-mode-switch": "",
                                            swatches: _ctx.swatches
                                          }, null, 8, ["modelValue", "swatches"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex pt-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_menu, { "offset-y": "" }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, _mergeProps({
                                                    modelValue: 
                                                            _ctx.themeSettings.pages.tables.rows
                                                                .borderColor
                                                        ,
                                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((
                                                            _ctx.themeSettings.pages.tables.rows
                                                                .borderColor
                                                        ) = $event))
                                                  }, props, {
                                                    label: "Bordures",
                                                    readonly: "",
                                                    "hide-details": "",
                                                    disabled: _ctx.readonly,
                                                    density: "compact"
                                                  }), null, 16, ["modelValue", "disabled"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_color_picker, {
                                            modelValue: _ctx.themeSettings.pages.tables.rows.borderColor,
                                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.themeSettings.pages.tables.rows.borderColor) = $event)),
                                            "show-swatches": "",
                                            "hide-sliders": "",
                                            "hide-inputs": "",
                                            "hide-mode-switch": "",
                                            swatches: _ctx.swatches
                                          }, null, 8, ["modelValue", "swatches"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex pl-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: _ctx.themeSettings.pages.tables.rows.border,
                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.themeSettings.pages.tables.rows.border) = $event)),
                                        label: "Bordures",
                                        disabled: _ctx.readonly
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex pt-2"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_menu, { "offset-y": "" }, {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_row, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, { cols: "12" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_text_field_filled, _mergeProps({
                                                    modelValue: 
                                                            _ctx.themeSettings.pages.tables.footer
                                                                .totalColorSeparator
                                                        ,
                                                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((
                                                            _ctx.themeSettings.pages.tables.footer
                                                                .totalColorSeparator
                                                        ) = $event))
                                                  }, props, {
                                                    label: "Couleur séparateur",
                                                    readonly: "",
                                                    disabled: _ctx.readonly,
                                                    "hide-details": "",
                                                    density: "compact"
                                                  }), null, 16, ["modelValue", "disabled"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_color_picker, {
                                            modelValue: 
                                                _ctx.themeSettings.pages.tables.footer
                                                    .totalColorSeparator
                                            ,
                                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((
                                                _ctx.themeSettings.pages.tables.footer
                                                    .totalColorSeparator
                                            ) = $event)),
                                            "show-swatches": "",
                                            "hide-sliders": "",
                                            "hide-inputs": "",
                                            "hide-mode-switch": "",
                                            swatches: _ctx.swatches
                                          }, null, 8, ["modelValue", "swatches"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_col, {
                                    cols: "4",
                                    class: "d-flex pl-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_checkbox, {
                                        modelValue: _ctx.themeSettings.pages.tables.footer.borderTop,
                                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.themeSettings.pages.tables.footer.borderTop) = $event)),
                                        label: "Séparateur Totaux",
                                        disabled: _ctx.readonly
                                      }, null, 8, ["modelValue", "disabled"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}